(function ($, angular, window) {
    'use strict';

    // 1234512345123451234512345
    // 123451234512345123451234512345
    // 12345123451234512345123451234512345
    
    window.THF.Angular.LiveQuoteTool.directive('thfFieldText', ['$sce', function ($sce) {
        var link = function (scope, el) {
            scope.lastKeyPressed = 0;
            scope.preventLengthyPaste = function(event) {
                if(typeof scope.field.maxLength === 'undefined') {
                    return true;
                }
                
                scope.lastKeyPressed = event.keyCode;
                
                var value = event.target.value;
                if(scope.lastKeyPressed != 8 && scope.lastKeyPressed != 46) {
                    scope.model[scope.field.name] = value.substring(0, scope.field.maxLength);
                }
            }
            scope.isValid = function(validationArray, key, type) {
                if( typeof validationArray === 'undefined' ) {
                    return true;
                } 

                if( typeof validationArray[key] === 'undefined' ) {
                    return true;
                }



                if(typeof type !== 'undefined' && typeof validationArray[key].details !== 'undefined') {

                    if(validationArray[key].details instanceof Array) {
                        var validationDetails = validationArray[key].details.filter(function(item) {
                            return item.type === type;
                        });
                        if(validationDetails.length > 0) {
                            var detail = validationDetails[0];

                            return detail.result;
                        }
                    }

                    return false;
                }
                else {
                    return validationArray[key].result;
                }


                return true;
            };

            scope.labelIdentifier = uuidv4();
            function uuidv4() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                    return v.toString(16);
                });
            }
        };
        return { 
            'restrict': 'E',
            'replace': true,
            'scope': {
                'field': '=',
                'validation': '=',
                'model': '=',
                'focus': '&',
                'blur': '&'
            },
            'link': link,
            'templateUrl': function () {
                return THF.Utility.Location.cacheBustUrl('/static/views/live-quote-tool/fields/text.html');
            }
        };
    }]);
})(jQuery, angular, window);
